import { useState } from '@wordpress/element';
import { Select } from 'antd';
import { DefaultOptionType } from 'antd/es/select';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { SvgIcon } from '../../../../components/svg-icon/svg-icon';
import './opening-time-duration.scss';
import './../../opening-time-page.scss';
import { Schedule } from '../../../../core/models/schedule';

type OpeningTimeDurationProps = {
	schedule: Schedule[];
	onChangeSchedule: (schedule: Schedule[]) => void;
};

export const OpeningTimeDuration: React.FC<OpeningTimeDurationProps> = (props: OpeningTimeDurationProps) => {
	const { t } = useTranslation();
	const [durationOptions, setDurationOptions] = useState<DefaultOptionType[] | undefined>([]);

	useEffect(() => {
		const durations: DefaultOptionType[] = [];

		const step = 5;
		const maxSteps = 12;

		for (let i = 1; i <= maxSteps; i++) {
			const value = i * step;
			const label = `${i * step}min`;
			durations.push({ value, label });
		}

		setDurationOptions(durations);
	}, []);

	const onChangeDuration = (value: number) => {
		const updatedSchedule = props.schedule.map((entry) => {
			entry.defaultDuration = value;
			return entry;
		});

		props.onChangeSchedule(updatedSchedule);
	};

	return (
		<div className='opening-time-duration'>
			<div className='opening-time-column-title  col'>{t('backEnd.openingTime.defaultDuration')}</div>
			<div className='col'>
				<Select
					showSearch
					onChange={onChangeDuration}
					prefix={<SvgIcon name='time' size={16} />}
					options={durationOptions}
					defaultValue={props.schedule[0].defaultDuration}
				/>
			</div>
			<div className='col'> </div>
		</div>
	);
};
